import React from "react";

const DetailsAndFacts = ({ info }) => {
    if (!info) return null;

    const {
        beds,
        baths,
        full_baths,
        half_baths,
        appliances,
        heating,
        cooling,
        flooring,
        fireplace,
        laundry_features,
        year_built,
        water,
        sewer,
        pool_features,
        parking_features,
        zoning,
    } = info;

    const renderItem = (label, value, fallback = null) =>
        value !== null && value !== undefined && value !== "" ? (
            <li>
                {label}: {value}
            </li>
        ) : fallback ? (
            <li>
                {label}: {fallback}
            </li>
        ) : null;

    return (
        <div className="tw-max-w-full tw-mx-4 tw-mt-4 tw-bg-white">
            <div className="tw-mb-8 tw-grid tw-grid-cols-2 max-sm:tw-flex-col">
                {/* Bedrooms & Bathrooms */}
                {(beds || baths || full_baths || half_baths) && (
                    <div className="tw-mb-6 max-sm:tw-w-full">
                        <h4 className="tw-text-[16px] tw-font-semibold tw-text-gray-700 tw-mb-3">Bedrooms & bathrooms</h4>
                        <ul className="tw-ml-4 tw-list-disc tw-space-y-2 tw-text-[16px] tw-text-gray-600 tw-text-start">
                            {renderItem("Bedrooms", beds)}
                            {renderItem("Bathrooms", baths)}
                            {renderItem("Full bathrooms", full_baths)}
                            {renderItem("1/2 bathrooms", half_baths)}
                        </ul>
                    </div>
                )}

                {/* Appliances */}
                {(appliances || laundry_features) && (
                    <div className="tw-mb-6 max-sm:tw-w-full">
                        <h4 className="tw-text-[16px] tw-font-semibold tw-text-gray-700 tw-mb-3">Appliances</h4>
                        <ul className="tw-ml-4 tw-list-disc tw-space-y-2 tw-text-[16px] tw-text-gray-600 tw-text-start">
                            {renderItem("Included", appliances)}
                            {renderItem("Laundry", laundry_features)}
                        </ul>
                    </div>
                )}

                {/* Features */}
                {(cooling ||
                    heating ||
                    flooring ||
                    fireplace !== null ||
                    parking_features ||
                    pool_features ||
                    water ||
                    sewer ||
                    year_built ||
                    zoning) && (
                    <div className="tw-mb-6 tw-w-full max-sm:tw-mt-6">
                        <h4 className="tw-text-[16px] tw-font-semibold tw-text-gray-700 tw-mb-3">Features</h4>
                        <ul className="tw-ml-4 tw-list-disc tw-space-y-2 tw-text-[16px] tw-text-gray-600 tw-text-start">
                            {renderItem("Cooling", cooling)}
                            {renderItem("Heating", heating)}
                            {renderItem("Flooring", flooring)}
                            {fireplace !== null && fireplace !== undefined && <li>Has fireplace: {fireplace ? "Yes" : "No"}</li>}
                            {renderItem("Parking", parking_features)}
                            {renderItem("Pool", pool_features)}
                            {renderItem("Water", water)}
                            {renderItem("Sewer", sewer)}
                            {renderItem("Year Built", year_built)}
                            {renderItem("Zoning", zoning)}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DetailsAndFacts;
